import { render, staticRenderFns } from "./typeProportion.vue?vue&type=template&id=63754d90&scoped=true"
import script from "./typeProportion.vue?vue&type=script&lang=js"
export * from "./typeProportion.vue?vue&type=script&lang=js"
import style0 from "./typeProportion.vue?vue&type=style&index=0&id=63754d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63754d90",
  null
  
)

export default component.exports